import React from 'react';
import PropTypes from 'prop-types';
import { Route, useHistory } from 'react-router-dom';
import NotFound from 'components/atoms/notFound';
import { userHasAccess } from 'utils/accessManager/index';
import useUser from 'utils/useUser';

const AccessRoute = ({ component: Component, path, ...props }) => {
  const {
    location: { pathname },
  } = useHistory();
  const user = useUser();
  const paths = user.userType === 'patient' ? pathname : path;
  const hasAccess = userHasAccess(user, paths);
  return (
    <Route
      {...props}
      render={() => {
        if (!hasAccess) {
          return <NotFound />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

AccessRoute.propTypes = {
  component: PropTypes.func,
  path: PropTypes.string.isRequired,
};

export default AccessRoute;
